import * as React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { MarketTemplate } from "../../../../data";
import { prepareEmptyMarket, valueOrDefault } from "../../../../helpers";
import { BetButtonsWrapLiveOutright } from "../BetButtonsWrapLiveOutright";
export const MarketsWrapLiveOutright = observer((props) => {
    var _a;
    const market = props.details.markets && props.details.markets.length && props.details.markets[0].selections.length > 0
        ? toJS(props.details.markets[0])
        : prepareEmptyMarket(props.details.event.id, valueOrDefault((_a = props.details.markets[0]) === null || _a === void 0 ? void 0 : _a.marketType.id, ""), MarketTemplate.ThreeBox, 0);
    market.template = MarketTemplate.ThreeBox; // this should be done in the parser  !!!!
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__buttons-holder`, "data-uat": `div-ev-list-${props.componentPrefix}-buttons-holder` },
        React.createElement(BetButtonsWrapLiveOutright, { details: props.details, market: market, componentPrefix: props.componentPrefix })));
});
//# sourceMappingURL=MarketsWrapLiveOutright.js.map